<template>
  <div class="flex flex-row p-1">
    <pbc-button v-if='enableEditButton && component.type === "sprite"'  @click='onInstantEdit'  class='main-info-button pbc-primary-color'>
      <div class="main-info-button-description flex flex-row m-0 p-0">
        <image-icon :size='16' />
        <span class="ml-2 mr-2 text-xs">Change</span>
      </div>
    </pbc-button>
    <pbc-button v-else-if='enableEditButton && component.type === "text"' @click='onInstantEdit' class='main-info-button'>
      <div class="main-info-button-description flex flex-row m-0 p-0">
        <format-text :size='16' />
        <span class="ml-2 mr-2 text-xs">Change</span>
      </div>
    </pbc-button>
    <pbc-button v-else-if='enableEditButton'  @click='$emit("edit")' class='main-info-button'>
      <div class="main-info-button-description flex flex-row m-0 p-0">
        <component :is='ComponentIcon' :size='16' />
        <span class="ml-2 mr-2">Edit</span>
      </div>
    </pbc-button>

    <quick-animate v-if='component.type === "tween"'
                   :component='component'
                   :transform='transform'
                   :partutil='partutil'
                   class="overflow-x-auto overflow-y-hidden"
                   @change='$emit("change", $event)'
                   :transforms-and-source='transformsAndSource' />
    <quick-move v-if='component.type === "move"'
                   :transform='transform'
                   :component='component'
                   :partutil='partutil'
                   @change='$emit("change", $event)'
                   :transforms-and-source='transformsAndSource' />
    <quick-automove v-if='component.type === "automove"'
                   :transform='transform'
                   :component='component'
                   :partutil='partutil'
                   @change='$emit("change", $event)'
                   :transforms-and-source='transformsAndSource' />
      <!--
    <recommender :gamedata='partutil.gamedata'
                  :partutil='partutil'
                  :component='component'
                  :transform='transform'
                  v-on='$listeners'
                  :key='component.id'
                />
      -->

  </div>
</template>
<script>
import Recommender from '@ui/organisms/Recommender.vue';
import QuickAnimate from '@ui/organisms/QuickAnimate.vue';
import QuickMove from '@ui/organisms/QuickMove.vue';
import QuickAutomove from '@ui/organisms/QuickAutomove.vue';
import Image from '@icons/Image.vue';
import FormatText from '@icons/FormatText.vue';
//import Pencil from '@icons/Pencil.vue';
import iconMapping from '@/components/iconMapping.js';

export default {
  props: {
    transform: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    gamedata: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    enableEditButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const ComponentIcon = iconMapping[this.component.type];
    return {
      ComponentIcon
    }
  },
  components: {
    ImageIcon: Image,
    FormatText,
    //Recommender,
    QuickAnimate,
    QuickMove,
    QuickAutomove
  },
  methods: {
    onInstantEdit() {
      this.$emit("edit");
    }
  },
  watch:{
    component:{
      handler() {
        this.$emit('change-component', this.component);
      },
      deep: true
    },
  }
}
</script>
